import { RAGAS, SA_OPTIONS, DEVANAGARI, SWARA_NAMES } from './audio.js';

export function createUI({ audio, onMode, onReady }) {
  const hud = document.getElementById('hud');
  const loader = document.getElementById('loader');
  const hint = document.getElementById('hint');
  const noteLabel = document.getElementById('note-label');
  const noteSub = document.getElementById('note-sub');
  const ragaSelect = document.getElementById('raga-select');
  const saSelect = document.getElementById('sa-select');
  const droneToggle = document.getElementById('drone-toggle');
  const snapToggle = document.getElementById('snap-toggle');
  const stringRow = document.getElementById('string-row');
  const swaraRow = document.getElementById('swara-row');
  const btnLook = document.getElementById('btn-look');
  const btnPlay = document.getElementById('btn-play');

  const strings = [
    { id: 2, name: 'Kharaj', sub: 'low Sa' },
    { id: 1, name: 'Pancham', sub: 'Pa' },
    { id: 0, name: 'Sur', sub: 'Sa' },
  ];

  strings.forEach((s) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'chip' + (s.id === 0 ? ' is-active' : '');
    b.dataset.string = String(s.id);
    b.innerHTML = `${s.name}`;
    b.addEventListener('click', () => onReady.selectString(s.id));
    stringRow.appendChild(b);
  });

  Object.values(RAGAS).forEach((r) => {
    const o = document.createElement('option');
    o.value = r.id;
    o.textContent = r.name;
    if (r.id === 'yaman') o.selected = true;
    ragaSelect.appendChild(o);
  });

  SA_OPTIONS.forEach((s, i) => {
    const o = document.createElement('option');
    o.value = String(s.hz);
    o.textContent = s.label;
    if (i === 1) o.selected = true;
    saSelect.appendChild(o);
  });

  function paintSwaras() {
    swaraRow.replaceChildren();
    const tokens = audio.displaySwaras();
    tokens.forEach((token) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'swara';
      b.dataset.token = token;
      const base = token === 'S2' ? 'S' : token;
      b.innerHTML = `<b>${DEVANAGARI[base]}</b><small>${token === 'S2' ? "Sa'" : SWARA_NAMES[base]}</small>`;
      b.addEventListener('pointerdown', (e) => {
        e.preventDefault();
        audio.unlock();
        onReady.triggerSwara(token);
        b.classList.add('is-down');
      });
      const up = () => {
        onReady.releaseSwara(token);
        b.classList.remove('is-down');
      };
      b.addEventListener('pointerup', up);
      b.addEventListener('pointerleave', up);
      swaraRow.appendChild(b);
    });
  }

  ragaSelect.addEventListener('change', () => {
    audio.setRaga(ragaSelect.value);
    paintSwaras();
  });
  saSelect.addEventListener('change', () => audio.setSa(Number(saSelect.value)));
  droneToggle.addEventListener('change', () => {
    audio.unlock().then(() => audio.setDrone(droneToggle.checked));
  });
  snapToggle.addEventListener('change', () => onReady.setSnapping(snapToggle.checked));

  btnLook.addEventListener('click', () => onMode('look'));
  btnPlay.addEventListener('click', () => {
    audio.unlock();
    onMode('play');
  });

  paintSwaras();

  return {
    reveal() {
      loader.classList.add('is-done');
      hud.hidden = false;
      hud.classList.remove('is-hidden');
      setTimeout(() => loader.remove(), 520);
    },
    setMode(mode) {
      btnLook.classList.toggle('is-active', mode === 'look');
      btnPlay.classList.toggle('is-active', mode === 'play');
      hint.textContent =
        mode === 'look'
          ? 'Drag to orbit. Scroll to zoom. Right-drag to pan.'
          : 'Drag across the three gut strings to bow. Slide along the neck for meend.';
    },
    setString(id) {
      stringRow.querySelectorAll('.chip').forEach((el) => {
        el.classList.toggle('is-active', Number(el.dataset.string) === id);
      });
    },
    pressSwara(token, down) {
      swaraRow.querySelectorAll('.swara').forEach((el) => {
        if (el.dataset.token === token) el.classList.toggle('is-down', down);
      });
    },
    showNote(info) {
      if (!info) {
        noteLabel.classList.remove('is-on');
        noteSub.textContent = '';
        return;
      }
      noteLabel.textContent = info.deva || '';
      noteLabel.classList.add('is-on');
      noteSub.textContent = info.name || '';
    },
  };
}
